<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="3"></Process>
        </div>
        <div class="pb-8">
            <div class="flex justify-between items-center">
                <h2 class="font-bold text-2xl">
                    要保人聯絡資料確認
                </h2>
                <div v-if="!isChangeContactInfo" class="text-[#0093C1] textsm"
                    @click="() => { isChangeContactInfo = true }">
                    <div class="cursor-pointer">
                        <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20"
                            height="20" viewBox="0 0 24 24">
                            <title>square-edit-outline</title>
                            <path
                                d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                        </svg>變更聯絡方式
                    </div>
                </div>
            </div>
            <p class="pt-2">我們將發送簡訊動態密碼予您進行確認，請確認您的當前聯繫方式。</p>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-2">
                要保人：{{ name }}
            </h3>
            <p v-if="isChangeContactInfo" class="pb-2">同時變更以您為要保人於本公司投保之所有個人險有效及停效保單的行動電話及Email。</p>
            <ul>
                <li class="pb-4">
                    <h5 class="font-bold text-md pb-2">
                        行動電話
                    </h5>
                    <div class="flex">
                        <div class="w-1/4 pr-1">
                            <Multiselect v-model="mobileCountry" placeholder="國碼" :options="mobileCodeList"
                                :can-clear="false" class="select-base" :can-deselect="false"
                                :disabled="!isChangeContactInfo" />
                        </div>
                        <div class="w-3/4 pl-1">
                            <input :disabled="!isChangeContactInfo" class="w-full" type="text" v-model="phoneNumber"
                                placeholder="請輸入行動電話">
                        </div>
                    </div>
                </li>
                <li>
                    <h5 class="font-bold text-md pb-2">
                        E-mail
                    </h5>
                    <input :disabled="!isChangeContactInfo" class="w-full" type="text" v-model="email"
                        placeholder="請輸入電子信箱">
                </li>
            </ul>
            <CaseBox v-if="needAgreeMIDTerm" class="mt-6">
                <ul>
                    <li class="cursor-pointer py-3 flex" @click="(_e) => { showMIDTermBox = true }">
                        <div>
                            <div class="inline-block w-[20px] h-[20px] rounded-sm border align-bottom text-white"
                                :class="{ 'bg-[#0093C1] border-[#0093C1]': infoBoxBottomData.read }">
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                    style="width: 18px; height: 18px;">
                                    <title>check</title>
                                    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                                </svg>
                            </div>
                        </div>
                        <div class="flex-1 px-3">
                            {{ infoBoxBottomData.title }}
                        </div>
                        <div class="text-[#0093C1]">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                style="width: 24px; height: 24px;">
                                <title>chevron-right</title>
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                            </svg>
                        </div>
                    </li>
                </ul>
            </CaseBox>
            <ClauseBox v-if="showMIDTermBox" :infoBoxBottomData="infoBoxBottomData"
                :closeHandle="() => { showMIDTermBox = false }" @updateInfoBoxBottom="updateInfoBoxBottom" />
            <ClauseBox v-if="newMIDTermBox.show" :infoBoxBottomData="newMIDTermBox"
                :closeHandle="() => { newMIDTermBox.show = false; }"
                @updateInfoBoxBottom="updateInfoBoxBottomForNewMID" />
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!isAllowSubmit" @click="validateEmail">下一步</button>
        </template>
        <InfoBox v-if="choosePhoneBoxVisible" :closeHandel="() => { choosePhoneBoxVisible = false }"
            title="請選擇接收OTP行動電話" :ok-handel="hanldeChooseConfirm" :disableConfirmBtn="disableBtn">
            您本次同時辦理要保人行動電話變更，請選擇以哪個行動電話進行本次申請之動態行動密碼驗證？
            <div class="list-box box--shadow bg-white rounded-md overflow-hidden border border-white pt-2">
                <label>
                    <div class="px-4 flex">
                        <div class="pr-3">
                            <input class="w-[20px] h-[20px] align-text-bottom" type="radio" :value="phoneNumber"
                                v-model="choosedPhoneNumber" name="otpNumber" />
                        </div>
                        <div>
                            <div class="pr-2 text-lg">
                                新號碼 {{ maskMobile(phoneNumber) }}
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <div class="list-box box--shadow bg-white rounded-md overflow-hidden border border-white pt-2">
                <label>
                    <div class="px-4 flex">
                        <div class="pr-3">
                            <input class="w-[20px] h-[20px] align-text-bottom" type="radio" :value="storedData.mobile"
                                v-model="choosedPhoneNumber" name="otpNumber" />
                        </div>
                        <div>
                            <div class="pr-2 text-lg">
                                原號碼 {{ maskMobile(storedData.mobile) }}
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </InfoBox>
        <Loading :is-loading="isLoading" />
        <InfoBoxBottomEmail v-if="showValidateEmailBox" :email="email" :closeHandle="() => showValidateEmailBox = false"
            :nextStep="goNextPage" />
    </Layout>
</template>
<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import routeName from '@/router/constant';
import Multiselect from '@vueform/multiselect';
import aplCatlCode from '@/json/aplCatlCode';
import { ref, watch, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getMobileCodeInfo } from '@/apis/applicantChange';
import { getNeedMIDVerify, getMidClause, submitMidVerify, postNeedCecMIDVerify, postCecMIDVerify } from '@/apis/mid'
import { getLoanContactInfo, postLoanSubmitContact } from '@/apis/CloudECounter';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import ClauseBox from '@/components/cloudCounter/clauseBox.vue';
import { maskMobile, maskEmail } from '@/utils/maskUtils.js';
import Loading from '@/components/Loading.vue';
import InfoBoxBottomEmail from '@/components/cloudCounter/InfoBoxBottomEmail.vue';

const store = useStore();
const router = useRouter();
const isChangeContactInfo = ref(false);
const name = ref('');
const storedData = reactive({});
const phoneNumber = ref('');
const email = ref('');
const mobileCodeList = ref([]);
const mobileCountry = ref('');
const choosePhoneBoxVisible = ref(false);
const choosedPhoneNumber = ref(null);
const titleText = ref('');
const infoBoxBottomData = reactive({
    title: 'Mobile ID 門號認證服務使用者約定條款及隱私權告知條款',
    content: '',
    read: false,
});
const showMIDTermBox = ref(false);
const needAgreeMIDTerm = ref(false);
const isLoading = ref(false);
const showValidateEmailBox = ref(false);
const newMIDTermBox = reactive({
    show: false,
    title: 'Mobile ID 門號認證服務使用者約定條款及隱私權告知條款',
    content: '',
    read: false,
    needMID: false,
})

const aplCatl = computed(() => store.state.services.aplCatl);
if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
} else if (aplCatl.value === aplCatlCode.LOAN) {
    titleText.value = '保單借款'
}

const isAllowSubmit = computed(() => {
    const validateResult = phoneNumber.value && email.value && mobileCountry.value;
    return needAgreeMIDTerm.value ? infoBoxBottomData.read && validateResult : validateResult;
})

const disableBtn = computed(() => {
    return !Boolean(choosedPhoneNumber.value);
})

// call api get data
const initData = async () => {
    isLoading.value = true;
    try {
        const res = await Promise.all([getMobileCodeInfo(), getLoanContactInfo(),]);
        const mobileCodeRes = res[0];
        mobileCodeList.value = mobileCodeRes.data?.mobileCodeList.map(i => { return i.value });

        const contactInfoRes = res[1];
        Object.assign(storedData, contactInfoRes.data)
        mobileCountry.value = contactInfoRes.data?.mobileCountry;
        name.value = contactInfoRes.data?.applicantName;
        if (!contactInfoRes.data?.mobile || !contactInfoRes.data?.email) {
            isChangeContactInfo.value = true;
            phoneNumber.value = contactInfoRes.data?.mobile || '';
            email.value = contactInfoRes.data?.email || '';
        } else {
            phoneNumber.value = maskMobile(contactInfoRes.data?.mobile);
            email.value = maskEmail(contactInfoRes.data?.email);
        }

        const needMidRes = await getNeedMIDVerify();
        needAgreeMIDTerm.value = needMidRes.data?.flag;
        if (needMidRes.data?.flag) {
            const midClauseRes = await getMidClause();
            infoBoxBottomData.content = midClauseRes.data?.html;
        }
    } catch (ex) { } finally {
        isLoading.value = false;
    }
}
initData();

const submit = async (data) => {
    isLoading.value = true;
    try {
        const res = await postLoanSubmitContact(data);
        router.push({ name: routeName.CLOUD_E_COUNTER_APPLY_OTP })
    } catch (ex) { } finally {
        isLoading.value = false;
    }
}

const hanldeChooseConfirm = () => {
    if (!choosedPhoneNumber.value) {
        return;
    }
    submit({
        mobileCountry: mobileCountry.value,
        mobile: choosedPhoneNumber.value,
        email: isChangeContactInfo.value ? email.value : storedData.email,
        // 要保人輸入的新電話號碼
        mobileNew: phoneNumber.value,
    })
}

const goNextPage = async () => {
    if (isChangeContactInfo.value && phoneNumber.value !== storedData.mobile) {
        showValidateEmailBox.value = false;
        // call new API check require MID verify
        try {
            isLoading.value = true
            const result = await postNeedCecMIDVerify({ midVerifyMobile: phoneNumber.value })
            if (result.data?.flag) {
                const midClauseRes = await getMidClause();
                newMIDTermBox.show = true;
                newMIDTermBox.content = midClauseRes.data?.html;
            } else {
                // 有留存電話才彈出選擇視窗
                if (storedData.mobile) {
                    choosePhoneBoxVisible.value = true;
                } else {
                    submit({
                        mobileCountry: mobileCountry.value,
                        email: email.value,
                        mobile: phoneNumber.value,
                        mobileNew: phoneNumber.value,
                    });
                }
            }
        } finally {
            isLoading.value = false
        }
    } else {
        submit({
            mobileCountry: mobileCountry.value,
            email: isChangeContactInfo.value ? email.value : storedData.email,
            mobile: isChangeContactInfo.value ? phoneNumber.value : storedData.mobile,
            mobileNew: '',
        });
    }
}

const updateInfoBoxBottom = async () => {
    const midVerifyRes = await submitMidVerify();
    infoBoxBottomData.read = true;
};

const updateInfoBoxBottomForNewMID = async () => {
    try {
        isLoading.value = true;
        await postCecMIDVerify({ midVerifyMobile: phoneNumber.value });
        newMIDTermBox.read = true;
        // 有留存電話才選擇
        if (storedData.mobile) {
            choosePhoneBoxVisible.value = true;
        } else {
            submit({
                mobileCountry: mobileCountry.value,
                email: email.value,
                mobile: phoneNumber.value,
                mobileNew: phoneNumber.value,
            });
        }
    } finally {
        isLoading.value = false;
    }
}

const validateEmail = async () => {
    if (!storedData.email || (isChangeContactInfo.value && storedData.email !== email.value)) {
        // show validate email box
        showValidateEmailBox.value = true;
    } else {
        goNextPage();
    }
}

watch(isChangeContactInfo, (newVal, oldVal) => {
    if (newVal) {
        phoneNumber.value = storedData.mobile;
        email.value = storedData.email;
    }
})

</script>
<style lang="scss" scoped>
.multiselect.select-base {
    @apply text-base xs:text-lg rounded-md pt-0.5 xs:py-1 border-gray-200;

    &.is-active.is-open {
        @apply z-[60];
    }

    .multiselect-dropdown {
        @apply z-[60];
    }

    &.multiselect.is-disabled {
        @apply border-gray-75 text-gray-300 bg-gray-100;

        .multiselect-placeholder {
            @apply text-gray-100;
        }

        .multiselect-caret {
            @apply opacity-10;
        }
    }

    .multiselect-single-label {
        @apply pr-6 pl-2 xs:pl-3 top-0.5;
    }

    .multiselect-search {
        @apply pl-2 xs:pl-3.5
    }

    .multiselect-placeholder {
        @apply text-gray-250 px-2 xs:px-3 top-0.5;
    }

    .multiselect-option {
        @apply relative text-sm xs:text-base px-2 xs:px-3;

        &:not(:last-child)::after {
            @apply border-b w-[calc(100%-1rem)] absolute bottom-0 inset-x-2;
            content: '';
        }
    }

    .multiselect-caret {
        @apply w-3;
    }

    &.can-close .multiselect-single-label-text {
        @apply pr-4;
    }

    .multiselect-clear {
        @apply pr-2;
    }
}
</style>
